import { useEffect, useState } from 'react';

const useElementObserver = (selector: string): [Element | null, () => void] => {
  const [element, setElement] = useState<Element | null>(null);

  const removeElement = () => {
    setElement(null);
  };

  useEffect(() => {
    if (!selector) return;

    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Wenn ein Element im State gespeichert ist, überprüfen, ob es immer noch im DOM existiert
          if (element && !document.body.contains(element)) {
            setTimeout(() => {
              removeElement();
            }, 10);
          }

          // Wenn kein Element im State gespeichert ist, versuchen, das Element im DOM zu finden
          const foundElement = document.querySelector(selector);
          if (foundElement) {
            setElement(foundElement);
          }
        }
      });
    });

    observer.observe(document.body, { attributes: false, childList: true, subtree: true });

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, [selector, element]);

  return [element, removeElement];
};

export default useElementObserver;
